import { Clone, PartialUpdate } from '@/utils'

export default function(Template) {
  return function(data, options = {}) {
    let { strict = true } = options
    if (!data) return Clone(Template)
    return PartialUpdate(Clone(Template), data, strict)
  }
}
